import React, { useCallback, useEffect, useRef, useState } from 'react';
import FoldersAndFiles from './FoldersAndFiles';
import FolderAndFileSearch from './FolderAndFileSearch';
import './folderStyles.css';
const FolderAndFileManagement = _ref => {
  let {
    modelName,
    targetModelId,
    type,
    goToFolderQuery,
    fileUploaderUsers,
    getFileUploadersAndVirtualFolderPath,
    canEditExistingDocumentsOrFolders = true,
    rootFolderId = null,
    userClaimGroupAbilities
  } = _ref;
  const [query, setQuery] = useState('');
  const inputRef = useRef(null);
  const enableSearch = useCallback(event => {
    if (event.key === 'f' && event.key === 'f' && event.ctrlKey && document.activeElement !== inputRef.current) {
      event.preventDefault();
      inputRef.current.focus();
    }
  }, []);
  const disableSearch = useCallback(event => {
    if (event.key === 'Escape') {
      inputRef.current.blur();
      setQuery('');
    }
  }, []);
  useEffect(() => {
    document.addEventListener('keydown', enableSearch);
    document.addEventListener('keydown', disableSearch);
    return () => {
      document.removeEventListener('keydown', enableSearch);
      document.removeEventListener('keydown', disableSearch);
    };
  }, []);
  useEffect(() => {
    setQuery('');
  }, [targetModelId]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    "data-testid": "folderAndFilesDisplay"
  }, /*#__PURE__*/React.createElement(FoldersAndFiles, {
    targetModelId: targetModelId,
    type: type,
    modelName: modelName,
    goToFolderQuery: goToFolderQuery,
    getFileUploadersAndVirtualFolderPath: getFileUploadersAndVirtualFolderPath,
    canEditExistingDocumentsOrFolders: canEditExistingDocumentsOrFolders,
    rootFolderId: rootFolderId,
    userClaimGroupAbilities: userClaimGroupAbilities
  })));
};
export default FolderAndFileManagement;